import { render } from "./AddTaskForm.vue?vue&type=template&id=6b669dc5&scoped=true"
import script from "./AddTaskForm.vue?vue&type=script&lang=js"
export * from "./AddTaskForm.vue?vue&type=script&lang=js"

import "./AddTaskForm.vue?vue&type=style&index=0&id=6b669dc5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b669dc5"]])

export default __exports__